/*
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */

import { IAdaptor } from '../utils/IAdaptor';
import { ILoaEnrichment } from '../../../domain/models/ILoaEnrichment';
import LoaEnrichmentDto from '../../dto/LoaEnrichmentDto';

export default class LoaEnrichmentAdaptor implements IAdaptor<ILoaEnrichment, LoaEnrichmentDto> {
  /**
     * This property is used to map properties from FE to properties in BE, such that when requesting some fields,
     * or filtering by some fields, the infrastructure layer knows what to request from the BE.
     * */
  domainToDtoPropertiesMap: { [K in keyof ILoaEnrichment]?: keyof LoaEnrichmentDto } = {
    id: 'id',
    loaProof: 'loaProof',
    applicationId: 'applicationId',
    relativePath: 'relativePath',
    returnUrl: 'returnUrl'
  };

  /**
     * This is used mostly when we do get calls, so that data from BE is properly mapped to data in FE
     */
  fromDto(dto: LoaEnrichmentDto): Partial<ILoaEnrichment> {
    return {
      id: dto.id,
      loaProof: dto.loaProof,
      applicationId: dto.applicationId,
      relativePath: dto.relativePath,
      returnUrl: dto.returnUrl
    };
  }

  /**
     * This function is used to map FE Domain models to BE models.
     * It will be called when we send a domain model to the infrastructure, and it needs to send a Dto to BE (post, patch, put).
     * Bear in mind that you can just write the properties that you use,
     * no need to add the properties that you don't need to send over the network.
     */
  toDto(model: Partial<ILoaEnrichment>): Partial<LoaEnrichmentDto> {
    return {
      id: model.id,
      loaProof: model.loaProof,
      applicationId: model.applicationId,
      relativePath: model.relativePath,
      returnUrl: model.returnUrl
    };
  }
}
